module.exports = __webpack_public_path__ + "static/media/student-comment-prev.c65dfa99.png";